<template>
  <v-app-bar dense flat height="52" class="sh-bar" color="white">
    <router-link to="/" class="sh-logo">
      <img :src="require('@/assets/logo.svg')" alt="Kiey"/>
    </router-link>
    <nav class="sh-nav">
      <router-link to="/chat" active-class="active" class="sh-tab" exact>Chat</router-link>
      <router-link to="/chat/home-files" active-class="active" class="sh-tab">Home Files</router-link>
    </nav>
    <div class="sh-divider"></div>
    <Stories />
    <v-spacer/>
    <button v-if="!isElectron" class="sh-download-btn" @click="openDownloadModal" title="Download Desktop App">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
      <span class="sh-download-label">Desktop App</span>
    </button>
    <span v-if="tenant_company_name" class="sh-team">{{ tenant_company_name }}</span>
    <SwitchAccount />
    <router-link :to="profileRoute" class="sh-user">
      <UserAvatar :item="this.logged" :size="'30'" class="sh-avatar"/>
      <span class="sh-name">{{ logged.first_name }} {{ logged.last_name }}</span>
    </router-link>
    <button class="sh-logout" @click="logout" title="Log out">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
    </button>

  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import SwitchAccount from "@/components/SwitchAccount";
import UserAvatar from "@/components/UserAvatar";
import Stories from "@/views/chat/Stories";

const DOWNLOAD_BASE = 'https://storage.googleapis.com/kiey-production.firebasestorage.app/desktop-releases';

export default {
  name: "SiteHeader",
  components: { SwitchAccount, UserAvatar, Stories },
  computed: {
    ...mapState({
      logged: (state) => state.Chat.logged,
      tenant_company_name: (state) => state.Chat.tenant_company_name,
    }),
    profileRoute() {
      const role = this.logged && this.logged.user_role;
      if (role === 'vendor' || role === 'employee') return '/vendor/vendor-admin-panel';
      return '/owner/owner-admin-panel';
    },
    isElectron() {
      return navigator.userAgent.includes('Electron');
    },
    detectedOS() {
      const p = navigator.platform || '';
      const ua = navigator.userAgent || '';
      if (p.startsWith('Mac') || ua.includes('Macintosh')) return 'macOS';
      if (p.startsWith('Win') || ua.includes('Windows')) return 'Windows';
      if (p.startsWith('Linux') || ua.includes('Linux')) return 'Linux';
      return null;
    },
    downloadUrls() {
      return {
        mac: `${DOWNLOAD_BASE}/Kiey-latest.dmg`,
        win: `${DOWNLOAD_BASE}/Kiey-latest-setup.exe`,
        winPortable: `${DOWNLOAD_BASE}/Kiey-latest-win.zip`,
        linux: `${DOWNLOAD_BASE}/Kiey-latest.AppImage`,
      };
    },
  },
  data: () => ({
    owner_id: "",
    image: require("@/assets/logo.svg"),
    drawer: false,
    _dlOverlay: null,
  }),
  methods: {
    logout() { this.$store.dispatch("Chat/logout"); },
    openDownloadModal() {
      // Render modal in document.body to escape v-app-bar clipping
      if (this._dlOverlay) {
        document.body.removeChild(this._dlOverlay);
        this._dlOverlay = null;
      }

      const overlay = document.createElement('div');
      overlay.className = 'dl-overlay';
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) this.closeDownloadModal();
      });

      const urls = this.downloadUrls;
      const detected = this.detectedOS;
      overlay.innerHTML = `
        <div class="dl-modal">
          <button class="dl-close" title="Close">&times;</button>
          <h3 class="dl-title">Download Kiey Desktop</h3>
          <p class="dl-subtitle">Choose your operating system</p>
          <div class="dl-options">
            <a href="${urls.mac}" class="dl-option">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
              <span class="dl-option-name">macOS</span>
              <span class="dl-option-ext">.dmg</span>
            </a>
            <a href="${urls.win}" class="dl-option">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor"><path d="M3 12V6.75l6-1.32v6.48L3 12zm6.38.1l8.62-.01V3.54l-8.62 1.9v6.66zM17.05 12H21V3.07l-3.95.87V12zM3 13l6 .09v6.43l-6-1.33V13zm6.38-.01v6.78l8.62 1.9v-8.67l-8.62-.01zM17.05 13v8.56L21 20.93V13h-3.95z"/></svg>
              <span class="dl-option-name">Windows</span>
              <span class="dl-option-ext">Installer</span>
            </a>
            <a href="${urls.winPortable}" class="dl-option">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor"><path d="M3 12V6.75l6-1.32v6.48L3 12zm6.38.1l8.62-.01V3.54l-8.62 1.9v6.66zM17.05 12H21V3.07l-3.95.87V12zM3 13l6 .09v6.43l-6-1.33V13zm6.38-.01v6.78l8.62 1.9v-8.67l-8.62-.01zM17.05 13v8.56L21 20.93V13h-3.95z"/></svg>
              <span class="dl-option-name">Windows</span>
              <span class="dl-option-ext">Portable</span>
            </a>
            <a href="${urls.linux}" class="dl-option">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor"><path d="M12.504 0c-.155 0-.315.008-.48.021-4.226.333-3.105 4.807-3.17 6.298-.076 1.092-.3 1.953-1.05 3.02-.885 1.051-2.127 2.75-2.716 4.521-.278.832-.41 1.684-.287 2.489a.424.424 0 00-.11.135c-.26.268-.45.6-.663.839-.199.199-.485.267-.797.4-.313.136-.658.269-.864.68-.09.189-.136.394-.132.602 0 .199.027.4.055.536.058.399.116.728.04.97-.249.68-.28 1.145-.106 1.484.174.334.535.47.94.601.81.2 1.91.135 2.774.6.926.466 1.866.67 2.616.47.526-.116.97-.464 1.208-.946.587-.003 1.23-.269 2.26-.334.699-.058 1.574.267 2.577.2.025.134.063.198.114.333l.003.003c.391.778 1.113 1.132 1.884 1.071.771-.06 1.592-.536 2.257-1.306.631-.765 1.683-1.084 2.378-1.503.348-.199.629-.469.649-.853.023-.4-.2-.811-.714-1.376v-.097l-.003-.003c-.17-.2-.25-.535-.338-.926-.2-.868-.398-2.111-1.297-2.543-.364-.174-.763-.2-1.169-.127-.373-.936-.887-2.006-1.606-2.94-.76-1.066-.982-1.927-1.058-3.019-.065-1.491 1.056-5.965-3.17-6.298A5.152 5.152 0 0012.504 0z"/></svg>
              <span class="dl-option-name">Linux</span>
              <span class="dl-option-ext">.AppImage</span>
            </a>
          </div>
          ${detected === 'Windows' ? `
            <div class="dl-windows-note">
              <div class="dl-windows-note__title">Windows will show two warnings &mdash; this is normal</div>
              <p class="dl-windows-note__intro">
                Kiey is a new app, so Windows hasn't built up a reputation for it yet.
                You may see one or both of these safety prompts &mdash; here's how to get past them:
              </p>
              <ol class="dl-windows-steps">
                <li>
                  <strong>Browser warning</strong> (if it appears)
                  <span class="dl-windows-step-detail">
                    &ldquo;Kiey-latest-setup.exe isn't commonly downloaded.&rdquo;
                    Open your browser's downloads list and click into the warning &mdash;
                    look for <strong>See more</strong>, the <strong>&hellip;</strong> menu, or the
                    <strong>&#8942;</strong> menu &mdash; then choose <strong>Keep</strong>.
                  </span>
                </li>
                <li>
                  <strong>SmartScreen popup</strong> when you open the installer
                  <span class="dl-windows-step-detail">
                    &ldquo;Windows protected your PC.&rdquo; You'll only see a <em>Don't run</em> button.
                    Click <strong>More info</strong> at the top of the popup &mdash; that reveals the
                    <strong>Run anyway</strong> button.
                  </span>
                </li>
              </ol>
              <p class="dl-windows-note__fallback">
                Still stuck? Use the <strong>Portable</strong> download instead &mdash; unzip and
                double-click <code>Kiey.exe</code>. The same warnings can appear on first run;
                click <strong>More info</strong> &rarr; <strong>Run anyway</strong> the same way.
              </p>
            </div>
          ` : ''}
          ${detected ? `<p class="dl-detected">Detected: <strong>${detected}</strong></p>` : ''}
        </div>
      `;

      overlay.querySelector('.dl-close').addEventListener('click', () => this.closeDownloadModal());
      overlay.querySelectorAll('.dl-option').forEach(el => {
        el.addEventListener('click', () => this.closeDownloadModal());
      });

      document.body.appendChild(overlay);
      this._dlOverlay = overlay;
    },
    closeDownloadModal() {
      if (this._dlOverlay) {
        document.body.removeChild(this._dlOverlay);
        this._dlOverlay = null;
      }
    },
  },
  beforeDestroy() {
    this.closeDownloadModal();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/chat-header.scss";

// Download modal — unscoped because it renders in document.body
.dl-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dl-modal {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  width: 480px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.dl-close {
  position: absolute;
  top: 12px; right: 16px;
  width: 28px; height: 28px;
  display: flex; align-items: center; justify-content: center;
  border: none; background: transparent;
  font-size: 22px; color: #8e8e93; cursor: pointer;
  border-radius: 50%;
  &:hover { background: rgba(0,0,0,0.06); color: #1a1a1a; }
}

.dl-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px;
}

.dl-subtitle {
  font-size: 13px;
  color: #8e8e93;
  margin: 0 0 20px;
}

.dl-options {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.dl-option {
  flex: 1 1 calc(25% - 10px);
  min-width: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 18px 8px;
  border: 1px solid #e5e5ea;
  border-radius: 12px;
  text-decoration: none;
  color: #3c3c43;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: #2c6bed;
    background: rgba(44, 107, 237, 0.04);
    color: #2c6bed;
  }
}

.dl-option-name {
  font-size: 13px;
  font-weight: 600;
}

.dl-option-ext {
  font-size: 10px;
  color: #8e8e93;
}

.dl-detected {
  text-align: center;
  margin: 16px 0 0;
  font-size: 11px;
  color: #8e8e93;
}

.dl-windows-note {
  margin: 16px 0 0;
  padding: 14px 16px;
  background: rgba(6, 29, 71, 0.06);
  border-left: 3px solid #061D47;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  color: #3c3c43;

  code {
    background: rgba(6, 29, 71, 0.1);
    padding: 1px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-family: Menlo, Monaco, Consolas, monospace;
  }
}

.dl-windows-note__title {
  font-weight: 700;
  color: #061D47;
  font-size: 13px;
  margin-bottom: 6px;
}

.dl-windows-note__intro {
  margin: 0 0 10px;
}

.dl-windows-steps {
  margin: 0 0 10px;
  padding-left: 20px;

  li {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.dl-windows-step-detail {
  display: block;
  margin-top: 2px;
  color: #5a5a60;
}

.dl-windows-note__fallback {
  margin: 10px 0 0;
  padding-top: 10px;
  border-top: 1px solid rgba(6, 29, 71, 0.1);
}
</style>

<style scoped lang="scss">
@import '../../views/chat/_variables';

.sh-bar {
  border-bottom: 1px solid $border !important;
  box-shadow: none !important;
  -webkit-app-region: drag;

  &::v-deep .v-toolbar__content {
    padding: 0 12px !important;
    gap: 4px;
  }

  // All interactive elements must be no-drag
  a, button, input, .v-btn, .v-badge, .v-menu {
    -webkit-app-region: no-drag;
  }
}

.sh-logo {
  display: flex;
  align-items: center;
  margin-right: 12px;
  img { height: 20px; width: auto; }
}

.sh-nav { display: flex; gap: 2px; }

.sh-tab {
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: $t3;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.12s;
  font-family: $font;

  &:hover { background: $hover; color: $t1; }
  &.active { background: rgba($accent, 0.08); color: $accent; }
}

.sh-divider {
  width: 1px;
  height: 20px;
  background: $border;
  margin: 0 6px;
  flex-shrink: 0;
}

.sh-team {
  font-size: 11px;
  font-weight: 600;
  color: $t2;
  font-family: $font;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 4px;
}

::v-deep .v-badge {
  cursor: pointer;
  .v-btn {
    &:hover { background: $hover; }
  }
  .v-badge__badge {
    font-size: 10px;
    height: 16px;
    min-width: 16px;
    padding: 0 4px;
  }
}

.sh-user {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  &:hover { background: $hover; }

  &::v-deep .v-avatar {
    border: none !important;
  }
}

.sh-name {
  font-size: 11px;
  font-weight: 500;
  color: $t1;
  font-family: $font;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sh-logout {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  color: $t3;
  transition: all 0.12s;
  &:hover { background: $hover; color: $t1; }
}

// Download button
.sh-download-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: $accent;
  font-family: $font;
  background: rgba($accent, 0.08);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.12s;
  white-space: nowrap;
  flex-shrink: 0;
  margin-right: 4px;
  &:hover { background: rgba($accent, 0.15); }
}

@media (max-width: 900px) {
  .sh-nav { display: none; }
  .sh-divider { display: none; }
  .sh-team { max-width: 80px; font-size: 10px; }
  .sh-name { max-width: 70px; font-size: 10px; }
  .sh-user { padding: 4px 4px; gap: 4px; }
  .sh-logo { margin-right: 6px; img { height: 18px; } }
  .sh-logout { width: 24px; height: 24px; }
  .sh-user::v-deep .v-avatar { width: 24px !important; height: 24px !important; }
  .sh-download-btn { padding: 3px 8px; font-size: 10px; }
}

@media (max-width: 768px) {
  .sh-team { display: none; }
  .sh-name { display: none; }
  .sh-bar::v-deep .v-toolbar__content { padding: 0 6px !important; gap: 2px; }
  .sh-logo { margin-right: 4px; img { height: 16px; } }
  .sh-logout { width: 20px; height: 20px; svg { width: 12px; height: 12px; } }
  .sh-user { padding: 2px; gap: 2px; }
  .sh-user::v-deep .v-avatar { width: 20px !important; height: 20px !important; }
  .sh-download-label { display: none; }
  .sh-download-btn { padding: 4px; margin-right: 2px; }
}

@media (max-width: 480px) {
  .sh-team { display: none; }
  .sh-name { display: none; }
  .sh-bar::v-deep .v-toolbar__content { padding: 0 6px !important; gap: 2px; }
  .sh-logo { margin-right: 6px; img { height: 16px; } }
  .sh-logout { width: 22px; height: 22px; svg { width: 12px; height: 12px; } }
  .sh-user::v-deep .v-avatar { width: 22px !important; height: 22px !important; }
}

@media (max-width: 360px) {
  .sh-bar::v-deep .v-toolbar__content { padding: 0 4px !important; gap: 1px; }
  .sh-logo { margin-right: 4px; img { height: 14px; } }
  .sh-logout { width: 20px; height: 20px; svg { width: 10px; height: 10px; } }
  .sh-user { padding: 2px; gap: 2px; }
  .sh-user::v-deep .v-avatar { width: 18px !important; height: 18px !important; }
}

@media (max-width: 280px) {
  .sh-bar::v-deep .v-toolbar__content { padding: 0 2px !important; }
  .sh-logo { margin-right: 2px; img { height: 12px; } }
  .sh-logout { width: 16px; height: 16px; svg { width: 8px; height: 8px; } }
  .sh-user::v-deep .v-avatar { width: 16px !important; height: 16px !important; }
}
</style>
